import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'backgroundUrl'
})
export class BackgroundUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    if (value) {
      return this.sanitizer.bypassSecurityTrustStyle(`url(\"${value}\")`);
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/background-url.pipe.ts